import React, { useContext, useEffect, useState } from "react";
import { IdentityContext } from "@react-beets/identity";
import Typography from "@mui/material/Typography";
import { getUserInvites } from "../../services/users";
import { getListings } from "../../services/listings";
import EmptyCard from "../../components/EmptyCard";
import Invite from "./Invite";

const getListing = (listings = [], unitId = "") => {
  return listings.find((x) => x.unitId === unitId);
};

function Tenant() {
  const { identity } = useContext(IdentityContext);
  const [invites, setInvites] = useState([]);
  const [listings, setListings] = useState([]);

  useEffect(() => {
    if (identity?.profile?.email) {
      getUserInvites(identity.profile.email).then((data) => {
        if (!data?.message) {
          setInvites(data);
        }
      });
    }
    getListings().then((data) => {
      if (!data?.message) {
        setListings(data);
      }
    });
  }, [identity]);

  if (!invites.length) {
    return (
      <EmptyCard>
        <Typography variant="body2" color="text.secondary">
          <span>You don't have any invites at this time.</span>
        </Typography>
      </EmptyCard>
    );
  }

  return (
    <>
      {invites?.map((invite, index) => (
        <Invite
          invite={{
            ...invite.invite,
            propertyId: invite.propertyId,
            unitId: invite.unitId,
          }}
          listing={getListing(listings, invite.unitId)}
          key={index}
        />
      ))}
    </>
  );
}

export default Tenant;
